import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class GetBookTitlesService extends BaseService {
  constructor(
    eventName = constants.FETCH_BOOK_TITLES_DATA,
    statusName = 'GetBookTitlesServiceStatus',
    storeName = 'bookTitles',
    { notifyWhenEmpty = true } = {}
  ) {
    super(eventName, statusName);
    this.storeName = storeName;
    this.notifyWhenEmpty = notifyWhenEmpty;
  }

  async handleEvent(eventName, event) {
    const apiConfig = event?.payload?.apiConfig || {};
    const identifierSource = apiConfig.identifierSource || {};
    const queryParams = new URLSearchParams();
    Object.entries(identifierSource).forEach(([key, value]) => {
      queryParams.append(key, String(value));
    });
    const urlWithQueryParams = `${constants.GET_BOOK_TITLES_URL}?${queryParams.toString()}`;
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(urlWithQueryParams, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(urlWithQueryParams, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data?.data?.length > 0) {
      Framework.getStoreRegistry().getStore(this.storeName).setResponse(response);
    } else {
      const notification = {
        open: true,
        message: 'Data Not Found',
        type: 'info'
      };
      const responseObj = {
        status: 'success',
        data: []
      };
      if (this.notifyWhenEmpty) {
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
      Framework.getStoreRegistry().getStore(this.storeName).setResponse(responseObj);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
